// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".feedbackText{position:relative;margin:10px 0 0 0}.feedbackTextTextarea{width:100%;height:50px;background:#fff;border:1px solid #ccc;border-radius:4px;font-size:13px}.feedbackTextButton{display:inline-grid;place-content:center;height:28px;width:100px;padding:0 15px;margin:10px 0 0 0;background:#333;border:none;border-radius:4px;font-size:12px;font-weight:600;color:#fff;cursor:pointer}.feedbackTextButton:focus{outline:none}", ""]);
// Exports
module.exports = exports;
